export default "__VITE_ASSET__Nou_43$2__"